export default "__VITE_ASSET__BRPl0Iv6__"